import {
  SUGGESTED_ANSWER_EXAMPLE,
  SUGGESTED_ANSWER_FIXED,
  SuggestedAnswerType,
} from 'global/constants';

export function getAnswerTypeLabel(
  answerType: SuggestedAnswerType | null | undefined
) {
  if (answerType === SUGGESTED_ANSWER_EXAMPLE) {
    return 'Example Answer';
  }
  if (answerType === SUGGESTED_ANSWER_FIXED) {
    return 'Fixed Answer';
  }

  return 'Answers may vary';
}
